import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { breakpoints, Button, Text, textVariants } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { seatButtonStyles } from '../../utils/styles';
import SeatTooltip from './SeatTooltip';
import SeatTooltipWithPriceBreakdown from './SeatTooltipWithPriceBreakdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectedSeatInitialsStyles = css`
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
`;
const BookableSeat = _ref => {
  let {
    carrier,
    column,
    isRyanairInTrip,
    isSelected,
    markup,
    onChange,
    price,
    row,
    seat,
    SeatIcon,
    seatTypeLabel,
    selectedSeatInitials
  } = _ref;
  const {
    t
  } = useTranslation();
  const handleClick = onChange({
    price,
    carrier,
    column,
    row,
    seat,
    markup
  });
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._1170})`);
  const id = `bookableSeat-${row}-${seat}`;
  const tooltipId = id;
  const shouldShowTooltip = !isSelected || !isDesktop;
  return /*#__PURE__*/_jsxs(Button, {
    className: seatButtonStyles,
    "data-seat-id": id,
    "data-testid": id,
    "data-tooltip-id": tooltipId,
    onClick: handleClick,
    children: [isSelected && /*#__PURE__*/_jsx(Text, {
      "aria-label": t('ScreenReader.Seatmap.Seat.Selected.Action'),
      className: selectedSeatInitialsStyles,
      variant: textVariants._12_BOLD,
      children: selectedSeatInitials
    }), SeatIcon && /*#__PURE__*/_jsx(SeatIcon, {
      "aria-hidden": "true"
    }), shouldShowTooltip && (isRyanairInTrip && carrier ? /*#__PURE__*/_jsx(SeatTooltipWithPriceBreakdown, {
      carrier: carrier,
      id: tooltipId,
      isDesktop: isDesktop,
      markup: markup,
      price: price,
      seat: seat,
      seatTypeLabel: seatTypeLabel
    }) : /*#__PURE__*/_jsx(SeatTooltip, {
      id: tooltipId,
      isDesktop: isDesktop,
      price: price,
      seat: seat,
      seatTypeLabel: seatTypeLabel
    }))]
  });
};
export default BookableSeat;
//# sourceMappingURL=BookableSeat.js.map